import { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { message } from 'antd'

interface FlashProps {
  flash?: {
    notice?: string
    alert?: string
    error?: string
    success?: string
  }
}

export default function FlashMessages() {
  const { props } = usePage<FlashProps>()
  const flash = props.flash

  useEffect(() => {
    if (flash?.notice) {
      message.success(flash.notice)
    }
    if (flash?.success) {
      message.success(flash.success)
    }
    if (flash?.alert) {
      message.warning(flash.alert)
    }
    if (flash?.error) {
      message.error(flash.error)
    }
  }, [flash])

  return null
}
